var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[(_vm.show)?_c('div',{staticClass:"account-expire-notice"},[_c('div',{staticClass:"notice-content"},[_vm._v(" "+_vm._s(_vm.noticeText)+" ")])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }